import store from '@/store'

const routes = [{
    path: '/operations/containers/:id',
    name: 'warehousecontainer',
    component: () => import('@/views/main/modules/Operations/Containers/ContainersGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Containers',
    },
}]

export default routes;
